import qs from 'querystring'
import Workspace from 'webmango-api/workspace/browser'
import DBConfig from 'webmango-db'
import IDBStore from './state/lib/IDBStore'
import { setup, getBaseURL } from './api'

export const DB = DBConfig()

/**
 * Get workspace singleton.
 */

let workspace
let workspaceID

export let preferences
export let tasks

export function setWorkspaceID (id) {
  if (!id) throw new Error('setWorkspaceID – no id')
  if (workspaceID && workspaceID !== id) throw new Error('setWorkspaceID – cannot set new id')
  workspaceID = id
  setup(id)

  preferences = new IDBStore(`${id}-preferences`)
  tasks = new IDBStore(`${id}-tasks`)
}

export function getWorkspaceID () {
  if (!workspaceID) throw new Error('getWorkspaceID – not set')
  return workspaceID
}

export function setWorkspace (config) {
  if (workspace) throw new Error('workspace already set')
  if (!config) throw new Error('getWorkspace – no config')
  const workspaceID = getWorkspaceID()
  workspace = new Workspace(workspaceID, { DB, config: config.config })
  global.workspace = workspace
  return workspace
}

export function getWorkspace () {
  if (!workspace) throw new Error('getWorkspace – not set')
  return workspace
}

export function isWorkspaceSet () {
  return !!workspace
}

export function clearWorkspace () {
  workspace = undefined
  workspaceID = undefined
}

export function getRedirectURL ({ to }) {
  return `${getBaseURL()}/redirect?${qs.stringify({ to })}`
}

export function getPlexusURL (path = '') {
  return getRedirectURL({
    to: `https://plexus.anu.edu.au${path}`
  })
}



// WEBPACK FOOTER //
// ../webmango-core/globals.js